<style>
.global-search-area {
	position: absolute;
	float: left;
	left: 50%;
	width: 40px;
	margin-left: -60px;
	z-index: 1;
}
.global-search-static {
	background-color: #2F4050;
	color: white;
	height: 20px;
	width: 120px;
	border-bottom-left-radius: 120px;
	border-bottom-right-radius: 120px;
	text-align: center;
	font-weight: 700;
}
.global-search-area .global-search-container {
	background-color: #2F4050;
	position: absolute;
	top: 0;
	margin-left: -75px;
	z-index: 1;
	width: 300px;
	border-bottom-left-radius: 60px;
	border-bottom-right-radius: 60px;
}
.global-search-content {
	width: 250px;
	margin: auto;
	padding-top: 10px;
}
</style>
<div class="global-search-area" *ngIf="sfhAuth.isAuthenticated()">
	<div class="global-search-static">360 Search</div>
	<div class="global-search-container" [@expand360Search]="show360Search" style="display: none;">
		<div class="global-search-content">
			<global-search #globalSearch id="rail360GlobalSearch" name="rail360GlobalSearch"></global-search>
		</div>
	</div>
</div>
